import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {
  ZIDNEY_PROFILE_IMAGE_URL,
  SHOW_LOGO_3DECOPAS_URL,
  ANIMATED_COVER_3DECOPAS_URL,
  SHOW_COVER_3DECOPAS_URL,
} from '../data/assets';

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage: themeMode === 'dark' ? 'url(/images/logos/logo_white.PNG)' : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '20vh',
          }}
        ></Container>
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          gutterBottom
          align={'center'}
          color={theme.palette.primary.main}
        >
          3 de Copas: conversaciones donde cada transformación es un brindis
        </Box>
        <Typography
          variant={'h6'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
        >
          Un espacio de TNO Network para hablar de cambio real: emociones, estilo de vida, autoconocimiento y cultura con un tono cercano y celebratorio. Tu marca puede acompañar esos momentos en los que la audiencia busca inspiración y herramientas para el día a día.
        </Typography>
        <Typography
          variant={'h5'}
          component={'p'}
          color={theme.palette.primary.main}
          align={'center'}
          sx={{ mt: 3, mb: 2, fontStyle: 'italic' }}
        >
          ¿Qué es 3 de Copas?
        </Typography>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://tnonetwork.com/show/3decopas"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            tnonetwork.com/show/3decopas
          </Link>
        </Typography>
        <Typography
          variant={'body1'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
          sx={{ mt: 1 }}
        >
          <strong>3 de Copas</strong> es un programa en el que la conversación importa tanto como el mensaje: invitados, historias y temas que invitan a reflexionar y a actuar. La propuesta se complementa con presencia en la app y web de TNO, redes del ecosistema y contenido On-Demand. Promoción oficial del programa en redes: <strong>jueves 3:00 PM</strong> (horario Venezuela) en TNO Network; confirma en cartelera y redes para ajustes puntuales de grilla.
        </Typography>

        <Box
          sx={{
            position: 'relative',
            width: '100%',
            maxWidth: 900,
            mx: 'auto',
            mt: 4,
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: 3,
            aspectRatio: '16 / 9',
            bgcolor: 'common.black',
          }}
        >
          <Box
            component="video"
            src={ANIMATED_COVER_3DECOPAS_URL}
            autoPlay
            muted
            loop
            playsInline
            poster={SHOW_COVER_3DECOPAS_URL}
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
          <Box
            component="img"
            src={SHOW_LOGO_3DECOPAS_URL}
            alt="Logo 3 de Copas"
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              maxWidth: { xs: '58%', sm: '42%' },
              maxHeight: '42%',
              width: 'auto',
              height: 'auto',
              objectFit: 'contain',
              pointerEvents: 'none',
              zIndex: 1,
              filter: 'drop-shadow(0 4px 14px rgba(0,0,0,0.5))',
            }}
          />
        </Box>
      </Box>

      <Box marginTop={6} marginBottom={4}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={3}>
            <Box display="flex" justifyContent="center">
              <Box
                component="img"
                src={ZIDNEY_PROFILE_IMAGE_URL}
                alt="Zidney Alzauro — ancla de 3 de Copas, TNO Network"
                sx={{
                  width: { xs: 200, sm: 250, md: 300 },
                  height: { xs: 200, sm: 250, md: 300 },
                  borderRadius: 2,
                  objectFit: 'cover',
                  boxShadow: 3,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={9}>
            <Typography
              variant={'h5'}
              fontWeight={700}
              gutterBottom
              color={theme.palette.primary.main}
            >
              NUESTRA ANCLA: ZIDNEY
            </Typography>
            <Typography
              variant={'body2'}
              color={'textSecondary'}
              sx={{ fontStyle: 'italic', mb: 2 }}
            >
              La voz que convierte cada episodio en un ritual de conversación y descubrimiento
            </Typography>
            <Typography
              variant={'body1'}
              color={'textSecondary'}
            >
              <strong>Zidney Alzauro</strong> conduce <strong>3 de Copas</strong> con energía auténtica y un enfoque en la transformación personal, el estilo de vida y los vínculos. Su manera de entrevistar y de tejer los temas genera confianza en la audiencia: un contexto natural para marcas que quieren sonar como recomendación, no como interrupción.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Who;
